import { oplogEmitter } from "@/drawing/meta/oplog";
import { activityEventRepository } from "@/repositories/activityEvent.repository";

/**
 * Capture d'oplog (couche app) : s'abonne à l'émetteur de la couche dessin et
 * persiste les events dans IndexedDB, taggés du `drawingId` courant.
 *
 * `start(drawingId)` à l'ouverture d'un dessin, `stop()` à la fermeture. Les events
 * sont capturés `localSaved: 0` (en mémoire uniquement) — cf. `DRActivityEvent` pour
 * le cycle de vie complet (localSaved → revisionId → synced).
 */
class OplogCapture {
  private drawingId: number | null = null;
  private unsubs: Array<() => void> = [];

  start(drawingId: number): void {
    this.stop();
    this.drawingId = drawingId;

    this.unsubs.push(
      oplogEmitter.onAdd((e) => {
        if (this.drawingId == null) return;
        void activityEventRepository.append({
          eventId: e.eventId,
          drawingId: this.drawingId,
          entityUid: e.entityUid,
          type: e.type,
          clientTs: e.clientTs,
          snapshot: e.snapshot,
          revisionId: null,
          synced: 0,
          localSaved: 0,
          failureCount: 0,
          excluded: 0,
        });
      })
    );

    this.unsubs.push(
      oplogEmitter.onRemove((eventId) => {
        void activityEventRepository.remove(eventId);
      })
    );
  }

  stop(): void {
    for (const u of this.unsubs) u();
    this.unsubs = [];
    this.drawingId = null;
  }
}

export const oplogCapture = new OplogCapture();
